export interface SampledStreamPoint {
  index: number;
  time: number;
  timeLabel: string;
}

export function sampleStreamTimeline(
  timeValues: unknown,
  options?: { maxPoints?: number }
): SampledStreamPoint[] {
  if (!Array.isArray(timeValues) || timeValues.length === 0) {
    return [];
  }

  const maxPoints = options?.maxPoints ?? 200;
  const step = Math.max(1, Math.floor(timeValues.length / Math.min(timeValues.length, maxPoints)));

  return timeValues
    .filter((_, index) => index % step === 0)
    .slice(0, maxPoints)
    .map((timeSeconds, sampledIndex) => {
      const originalIndex = sampledIndex * step;
      const time = Math.round(Number(timeSeconds));
      return {
        index: originalIndex,
        time,
        timeLabel: `${Math.floor(time / 60)}:${String(time % 60).padStart(2, '0')}`,
      };
    });
}
